import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import { CoreLibService } from './core-lib.service';


/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *hasAyFeature="'id1'">...</some-element>
 *
 *     <some-element *hasAnyFeature="['id1', 'id2']">...</some-element>
 * ``
 */
@Directive({
    selector: '[hasAnyClaim]',
    standalone: false
})
export class HasAnyClaimDirective {
  private claims: string[];

  constructor(private coreLibService: CoreLibService, private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef) {}

  @Input()
  set hasAnyClaim(value: string | string[]) {
    this.claims = typeof value === 'string' ? [value] : value;
    this.updateView();
    // Get notified each time authentication state changes.
    this.coreLibService.getUserChanges().subscribe(identity => this.updateView());
  }

  private updateView(): void {
    const hasAnyAuthority = this.coreLibService.hasAnyClaims(this.claims);
    this.viewContainerRef.clear();
    if (hasAnyAuthority) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
